/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useState } from 'react';
import {
    string, func, object, bool,
} from 'prop-types';
import Select from '@material-ui/core/Select';
import withStyles from '@material-ui/core/styles/withStyles';
import Typography from '@material-ui/core/Typography';
import TextField from '@material-ui/core/TextField';
import { useDispatch } from 'react-redux';

import { trackEvent } from '../../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';

const styles = () => ({
    quantityContainer: {
        margin: '20px 0',
        display: 'flex',
        padding: '10px',
        alignItems: 'center',
        width: 'fit-content',
        float: 'right',
    },
    cartQuantityContainer: {
        display: 'flex',
        alignItems: 'center',
        width: 'fit-content',
        float: 'right',
        '& .MuiInputBase-root': {
            background: '#F3F3F3',
        },
    },
    select: {
        border: '1px solid #ced4da',
        margin: '5px 0',
        background: 'white',
        padding: '2px 5px',
        '& .MuiSelect-select.MuiSelect-select': {
            textAlign: 'left',
            paddingLeft: '1rem',
        },
    },
});

const ProductQuantity = ({
    quantity, setProductQuantity, classes, label = '', isCart,
}) => {
    const [textFieldValue, setTextFieldValue] = useState(parseInt(quantity, 10));

    const dispatch = useDispatch();

    const getOptions = () => {
        const options = [];
        for (let i = 1; i < 11; i += 1) {
            if (i === 10) options.push(<option key={`option_${i}`} value={`${i}`}>10+</option>);
            else {
                options.push(<option key={`option_${i}`} value={`${i}`}>{i}</option>);
            }
        }
        return options;
    };

    const handleTextFieldChange = (e) => {
        // RegEx to get range between 1 - 99
        const rangeRegex = (/^[1-9][0-9]?$|^99$/);
        if (rangeRegex.test(e.target.value) || e.target.value === '') {
            setTextFieldValue(e.target.value);
        }
    };

    const handleProductQuantityChange = (value) => {
        dispatch(trackEvent({
            eventName: 'feature_interaction',
            eventCategory: isCart ? 'Cart Page' : 'Product Page',
            eventAction: 'Quantity Change',
            eventLabel: value,
        }));
        setProductQuantity(value);
        setTextFieldValue(value);
    };

    return (
        <div className={isCart ? classes.cartQuantityContainer : classes.quantityContainer}>
            <Typography
                style={{
                    fontWeight: 'bold',
                    margin: '0 10px',
                }}
            >
                {label || 'Quantity'}:
            </Typography>
            {parseInt(quantity, 10) >= 10 ? (
                <TextField
                    value={textFieldValue}
                    type="number"
                    onChange={handleTextFieldChange}
                    onBlur={() => handleProductQuantityChange(textFieldValue)}
                    InputProps={{ inputProps: { min: 1, max: 99 } }}
                    style={{
                        width: '66px',
                        height: '41px',
                        margin: '0 10px',
                    }}
                />
            ) : (
                <Select
                    native
                    value={quantity}
                    onChange={(e) => handleProductQuantityChange(e.target.value)}
                    style={{
                        margin: '0 10px',
                        width: '66px',
                        height: '41px',
                    }}
                    className={classes.select}
                    inputProps={{ 'aria-label': 'Quantity' }}
                >
                    {getOptions()}
                </Select>
            )}
        </div>
    );
};

ProductQuantity.propTypes = {
    quantity: string.isRequired,
    setProductQuantity: func.isRequired,
    classes: object.isRequired,
    label: string.isRequired,
    isCart: bool,
};

ProductQuantity.defaultProps = {
    isCart: false,
};

export default withStyles(styles)(ProductQuantity);
